import { encode } from "iconv-lite";
import { UIStrings } from "../loc/UIStrings";

export function isObjectEmpty(obj: any): boolean {
    if (!obj || typeof obj !== 'object') return true;
    for (const _ in obj) return false;
    return true;
}

export function isObjectValuesEmpty(obj: any): boolean {
    const values = Object.keys(obj).map(k => obj[k]);
    const validValues = values.filter(str => str);
    return validValues.length <= 0;
}

export function convertFileToBase64(fileData: string): Promise<string> {
    return new Promise((resolve, reject) => {
        const blob = new Blob([fileData], { type: "application/msword" });
        const reader = new FileReader();
        reader.onload = (ev) => {
            resolve(ev.target.result as string);
        };
        reader.onerror = (err) => reject(err);
        reader.readAsDataURL(blob);
    });
}

export function isFieldRequired(typeItems: any[], selectedDoc: any): boolean {
    const selectedDocId = selectedDoc.id;
    const currentField = typeItems.filter(item => item.docType.id === selectedDocId)[0];
    if (currentField?.isRequired)
        return currentField.isRequired
    else
        return false;
}


export function filterByMetaItems(obj: any) {
    let result = {};
    for (let key in obj) {
        if (key.includes("meta")) {
            result[key] = obj[key];
        }
    }
    return result;
}

export function excludeMetaItems(obj: any) {
    let result = {};
    for (let key in obj) {
        if (!key.includes("meta")) {
            result[key] = obj[key];
        }
    }
    return result;
}

export function b64EncodeUnicode(str: string) {
    const buffer = encode(str, "utf16le");
    return buffer.toString("base64");
}


export function getErrorMessage(errorResponse: any) {
    let message: string = "";
    if (errorResponse.errors) {
        const error = errorResponse.errors[0];
        message = error.message;
    }
    if (errorResponse.message) {
        message = errorResponse.message;
    }
    return message;
}

export function getAppStrings(locale: string) {
    return UIStrings.getLocaleStrings(locale);
}
